import CalendarRoot from '@/components/medispa-calendar/CalendarRoot';
import { deferJS } from '@/components/utils/defer';
import { createRoot } from 'react-dom/client';

function initCalendar() {
  const root = document.querySelector<HTMLElement>('.medispa-calendar--placeholder');
  if (!root) {
    throw new Error('Could not find medispa-calendar--placeholder element');
  }

  const reactRoot = createRoot(root);
  reactRoot.render(<CalendarRoot config={window.theme.medispaCalendarConfig} />);
}

deferJS(initCalendar, () => {
  return !!window?.SesamiSDK;
});
